import { PromotionCreditType } from '../../constants/promotion-credit-type.js';
import { isCalendarDate, toPrismaDate } from '../../dates/calendar-date.js';
import { parseFiniteNumber } from '../../parse-finite-number.js';
import { refineExpirationAfterIssued } from './refine-credit-dates.js';
import { refineCreditLines } from './refine-credit-lines.js';
function calendarDateOf(value) {
    return isCalendarDate(value) ? toPrismaDate(value) : null;
}
function refineLinesFitCredit(value, context) {
    if (value.lines.length === 0)
        return;
    if (value.promotionId === '') {
        context.addIssue({
            code: 'custom',
            message: 'Credit lines need a linked promotion.',
            path: ['promotionId'],
        });
    }
    if (value.promotionCreditTypeId !== String(PromotionCreditType.PROMOTION)) {
        context.addIssue({
            code: 'custom',
            message: 'Credit lines are only for Promotion credits.',
            path: ['promotionCreditTypeId'],
        });
    }
}
// The sum check waits until the amount and every line passed their own rules, so one bad field is not reported again as an amount mismatch.
function refineLinesAddUp(value, context) {
    if (value.lines.length === 0)
        return;
    const hasFieldIssue = context.issues.some((issue) => issue.path?.[0] === 'amount' || issue.path?.[0] === 'lines');
    if (hasFieldIssue)
        return;
    const numericLines = value.lines.map((line) => ({
        id: line.id?.toLowerCase() || undefined,
        productTreeId: line.productTreeId.toLowerCase(),
        quantity: Number(line.quantity),
        unitPrice: Number(line.unitPrice),
        percentageOff: Number(line.percentageOff),
        customerPaid: Number(line.customerPaid),
    }));
    refineCreditLines({ amount: parseFiniteNumber(value.amount), lines: numericLines }, context);
}
/** The rules that span fields and match the API's: date order, lines only on a linked Promotion credit, and the amount following the lines. */
export function refineCreditForm(value, context, { checkLinesSum = true } = {}) {
    refineExpirationAfterIssued({
        dateApplicable: calendarDateOf(value.dateApplicable),
        expirationDate: calendarDateOf(value.expirationDate),
    }, context);
    refineLinesFitCredit(value, context);
    if (checkLinesSum)
        refineLinesAddUp(value, context);
}
//# sourceMappingURL=refine-credit-form.js.map